// extracted by mini-css-extract-plugin
export default {"checkbox_round":"Cart_checkbox_round__BUH0v","blueColore":"Cart_blueColore__gZ-+O"};